var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRotatePhone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18.098 23H5.955V2h12.143v21Zm-1.557-1.548V3.548H7.512v17.904h9.03Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.571 4.309c-1.104-1.634-2.049-2.262-2.049-2.262v7.44h2.602c.2.893.319 1.899.319 3.017 0 5.084-2.86 7.611-2.98 7.718l1.01 1.178C20.62 21.28 24 18.337 24 12.504c0-4.095-1.51-6.872-2.435-8.195h.006ZM4.485 22.947s-.945-.628-2.05-2.262C1.51 19.362 0 16.585 0 12.49c0-5.834 3.38-8.77 3.533-8.896l1.012 1.177c-.122.107-2.981 2.634-2.981 7.72 0 1.117.12 2.122.319 3.015h2.602v7.441Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgRotatePhone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/RotatePhone.7de693a0d56077bbd6e025c6c996451e.svg";